module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/bergamo.19313fdebb5452992665b2f573d2fbff.jpg";